import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PM_Service_Interface } from 'src/app/Interface/PM_Service_Interface';
import { User_Interface } from 'src/app/Interface/User_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PM_ServiceService {

  constructor(private http: HttpClient) { }

  GetRecord(Token: String): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/PMService?token=" + Token).pipe(
      map(data => {
        return data as any
      })
    )
  }

  GetHistory(id: number,Token: String): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/PMService/GetHistory?id=" + id + "&token=" + Token).pipe(
      map(data => {
        return data as any
      })
    )
  }

  GetDashboard(Token: String): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/PMService/GetDashboard?token=" + Token).pipe(
      map(data => {
        return data as any
      })
    )
  }



  AddAddDevice(
    pm_program_id: number,
    deviceBehfa_id:number,
    Token: String): Observable<PM_Service_Interface> {
    const headers = new HttpHeaders().set('content-type', 'application/json');



    var body = {
      pm_program_id: pm_program_id,
      deviceBehfa_id : deviceBehfa_id,
      token: Token
    }

    return this.http.post(environment.BaseUrl + "Daro/PMService/AddDevice", body, { headers }).pipe(
      map(data => {
        return data as PM_Service_Interface
      })
    )

  }

  DeletePM(id: number, Token: String): Observable<PM_Service_Interface> {

    return this.http.get(environment.BaseUrl + "Daro/PMService/Delete?id=" + id + "&token=" + Token).pipe(
      map(data => {
        return data as PM_Service_Interface
      })
    )

  }


}
